import { render, staticRenderFns } from "./AdministratorDataInfo.vue?vue&type=template&id=0d77682e"
import script from "./AdministratorDataInfo.vue?vue&type=script&lang=js"
export * from "./AdministratorDataInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports